/**
 * SalesRepository
 *
 * Define os templates de contexto para eventos do domínio de vendas.
 */

const SalesRepository = {
  /**
   * Template para falha no export de vendas (POST /sale/export).
   * @param {{ dadosCount?: number, exportCharges?: boolean, filters?: object }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildExportContext(ctx = {}) {
    return {
      tags: { flow: 'sales_export', domain: 'sales' },
      extra: {
        dados_count: ctx.dadosCount,
        export_charges: ctx.exportCharges ?? false,
        filters: ctx.filters,
      },
    };
  },

  /**
   * Template para falha no relatório de vendas (GET /sale/report).
   * @param {{ dateRange?: object, filters?: object, typeDate?: string }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildReportContext(ctx = {}) {
    return {
      tags: { flow: 'sales_report', domain: 'sales' },
      extra: {
        date_range: ctx.dateRange,
        filters: ctx.filters,
        type_date: ctx.typeDate,
      },
    };
  },

  /**
   * Template para falha ao atualizar status de venda (PUT /sale/:id).
   * @param {{ saleId?: number|string, toStatus?: string }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildUpdateContext(ctx = {}) {
    return {
      tags: { flow: 'sale_update', domain: 'sales', to_status: ctx.toStatus ?? 'unknown' },
      extra: {
        sale_id: ctx.saleId,
        to_status: ctx.toStatus,
      },
    };
  },
};

export default SalesRepository;
